export default{
  top1: '概览',
  top2: '技术规格',
  dec: 'Takes 10 minutes to reconstruct a space (100 m²), which is only 1/20 of the time needed for conventional devices, provides 4K HD picture quality and immersive virtual strolling of real 3D spaces.',
  yushou: '【新品预售】',
  price: 'RMB 3,999',
  buy: 'Shop Now',
  tiaokuan: '* 付款成功后5个工作日内发货，默认顺丰快递包邮',
  guige: {
    name: '技术规格',
    dec: '注：本页面所列配置及参数均以实际上市产品为准，如有变更，恕不另行通知',
    arr: [
      {
        name: 'Size',
        val: ['Height: 130mm', 'Width: 47mm', 'Depth: 18mm', 'Weight: 115g']
      },
      {
        name: 'Fabric',
        val: [
          'Titanium',
          'Matte surface'
        ]
      },
      {
        name: 'Camera',
        val: ['f/2.0 aperture',
          '3200-pixels SONY sensor',
          '220° fisheye lens*2',
          'Optical lens*8',
          '30fps recording speed in 3K']
      },
      {
        name: 'Connection',
        val: ['Bluetooth: 5.0', 'WiFi：802.11a / b / g / n / ac']
      },
      {
        name: 'Battery',
        val: ['2000mAh', 'Quick charge through USB']
      },
      {
        name: 'Storage',
        val: ['128G Trans-flash Card', '120-minutes 3K video']
      },
      {
        name: 'Interface',
        val: ['microUSB', 'Tripod attachment hole']
      }
    ]
  },
  color: {
    key: '颜色',
    val: ' 静谧黑'
  },
  service: {
    key: '服务',
    type: '容量套餐（5G / 5年）',
    val: [
      'Exclusive 10 GB cloud capacity for 5 years',
      'Upload speed up to 6 M/s',
      'Supports sharing on various social media platforms',
      'Supports adding multimedia hotspots, privacy encryption, automatic generation of spatial models, and embedding multimedia and websites in 3D spaces'
    ]
  },
  gift: {
    key: '赠品',
    val: ' 官方拍摄支架 x 1'
  },
  count: {
    key: '数量'
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/purchasetow.js